import { useQuery } from '@apollo/client';
import React from 'react';
import Image from 'react-bootstrap/Image';
import { GetVanityPiecesQuery } from '../../../../../../__gqltypes__';
import { GET_VANITY_PIECES } from '../../../components/apolloQueries';
import SelectDropdown from '../../../components/SelectDropdown';

type Props = {
  value: string | null;
  onSelect: (vanityPieceId: string | null) => void;
};

/**
 * Picks the vanity piece spent to unlock an item with the "PIECES" acquisition
 * (managed in Customization Items > Vanity Pieces)
 */
export default function VanityPiecePicker({ value, onSelect }: Props) {
  const { data } = useQuery<GetVanityPiecesQuery>(GET_VANITY_PIECES);

  const options: Record<string, { value: React.ReactNode; searchValue: string }> = {};
  (data?.liveOps?.vanityPieces ?? []).forEach((piece) => {
    options[piece.id] = {
      value: (
        <>
          {piece.icon && (
            <Image roundedCircle className="img-profile mr-3" src={piece.icon} style={{ width: 20, height: 20 }} />
          )}
          {piece.name}
        </>
      ),
      searchValue: piece.name,
    };
  });

  return <SelectDropdown title="Select vanity piece" options={options} value={value} onSelect={onSelect} />;
}
